import React, { FC } from 'react'
import style from './style.m.less'
import classNames from 'classnames'

export interface ICardInfoBlock {
    label?: string
    value: React.ReactNode
    icon?: React.ReactNode
    gap?: number
    customBlockStyle?: React.CSSProperties
    className?: string
}

const CardInfoBlock: FC<ICardInfoBlock> = ({
    label,
    value,
    icon,
    gap,
    customBlockStyle,
    className,
}) => {
    const baseStyle = style.infoBlockMain
    return (
        <div className={classNames(baseStyle, className)} style={customBlockStyle}>
            {label && <div className={style.label}>{label}</div>}
            <div className={style.iconBlock}>
                {icon && icon}
                <div style={{ marginLeft: `${gap}px` }}>{value}</div>
            </div>
        </div>
    )
}

export default CardInfoBlock
